import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import { useReturnStore } from '../../stores/returnStore';
import { TagOnReturnSummaryPage } from '../../utils/analytics-tagging';
import { useSummaryStore } from '../../stores/summaryStore';
import { RefundTotal } from '../shared/RefundTotal';
import SummaryItem from './SummaryItem';
import { NextSteps } from './next-steps/NextSteps';
export var ReturnSummary = function (_a) {
    var refundValues = _a.refundValues;
    var navigate = useNavigate();
    var orderDetailsV2 = useReturnStore(function (state) { return state.orderDetailsV2; });
    var isMilitaryExchangeGuest = useReturnStore(function (state) { return state.isMilitaryExchangeGuest; });
    var returnItems = useSummaryStore(function (state) { return state.selectedReturnItems; });
    var returnToInitialPage = function () {
        return isMilitaryExchangeGuest
            ? navigate("/myaccount/guest-order-tracking")
            : navigate("/myaccount/purchase-history");
    };
    useEffect(function () {
        if (orderDetailsV2) {
            TagOnReturnSummaryPage();
        }
    }, [orderDetailsV2]);
    return (React.createElement("div", null,
        React.createElement(NextSteps, null),
        React.createElement("div", { className: "lg:sui-w-4/12 sui-pt-6" },
            React.createElement("div", { className: "sui-mb-[32px]" },
                React.createElement("div", { className: "sui-flex sui-flex-col" },
                    React.createElement(Typography, { variant: "h3" }, "Your return items"),
                    returnItems.map(function (item, key) { return (React.createElement(SummaryItem, { item: item, key: key, isMilitaryExchangeGuest: isMilitaryExchangeGuest })); }))),
            React.createElement(RefundTotal, { sessionValues: refundValues }),
            React.createElement("div", { className: "card-fix sui-flex sui-flex-col back-to-purchase-history-button sui-w-full" },
                React.createElement(Button, { variant: "secondary", onClick: returnToInitialPage }, isMilitaryExchangeGuest
                    ? 'Track Another Order'
                    : 'Back to Purchase History')))));
};
